import classnames from "classnames";
import styles from "./BorderlessButton.module.scss";
import React from "react";

export const BorderlessButton = React.forwardRef(function BorderlessButton(
    { darker, solid, type = "button", className, children, ...props },
    ref
) {
    return (
        <button
            ref={ref}
            type={type}
            className={classnames(styles.button, { [styles.darker]: darker, [styles.solid]: solid }, className)}
            {...props}
        >
            {children}
        </button>
    );
});
